import { HeadingLevel } from "@viagogo/core/ui";
import { useAppContext } from "src/shared/context/AppContext";
import { MarketplaceDisclosure } from "src/website-apps/shared/components/disclosures";
import { ErrorMessage } from "src/website-apps/shared/components/ErrorMessage";
import { BrowseHeader } from "src/website-apps/shared/components/header/BrowseHeader";

/**
 * Header portion of the Layout component on Find
 */
export const FindLayoutHeader = ({ model, setMobileMenuOpen, mobileMenuOpen }) => {
  const appContext = useAppContext();
  const { header, marketplaceDisclosure, sellSearch } = model;
  const showMarketplaceDisclosure = !sellSearch && !!marketplaceDisclosure;

  return (
    <HeadingLevel>
      <ErrorMessage />
      {showMarketplaceDisclosure && <MarketplaceDisclosure marketplaceDisclosureSiteMessage={marketplaceDisclosure} />}
      {/* Not EventsGridContextAwareHeader: find is excluded from TMEnsembleAppNavHeader (103776). */}
      <BrowseHeader
        browseHeader
        bigPerformerBanner={false}
        disclaimerSameBackgroundAsHeader
        mobileMenuOpen={mobileMenuOpen}
        discoveryLinks={sellSearch ? null : header?.navigationBarLinks}
        isUserLoggedIn={appContext.isUserLoggedIn}
        onMobileMenuToggle={setMobileMenuOpen}
      />
    </HeadingLevel>
  );
};
